export default __webpack_public_path__ + "static/media/logo-white.260ed9df.svg";